/**
 * CMS API Proxy Client
 * 
 * replaces direct CMS API calls with calls to our Vercel serverless function
 */

const ContentProxy = {
  cache: {
    getEntries: {}
  },

  /**
   * Get entries from CMS via the proxy
   * @param {Object} query - CMS query parameters
   * @returns {Promise} Promise resolving to CMS entries
   */
  async getEntries(query) {
    const hashify = require('object-hash');
    const hashified = hashify(query);

    if (this.cache.getEntries[hashified]) {
      return Promise.resolve(this.cache.getEntries[hashified]);
    }

    try {
      const response = await fetch('/api/cms', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ query }),
      });

      if (!response.ok) {
        // Try to get error message, but don't expose internal details
        const errorData = await response.json().catch(() => ({}));
        const userMessage = errorData.message || 'Unable to fetch content. Please try again later.';
        throw new Error(userMessage);
      }

      const data = await response.json();

      this.cache.getEntries[hashified] = data;

      return data;
    } catch (error) {
      console.error('CMS proxy error:', error);
      throw error;
    }
  }
};

export default ContentProxy;

